import React from 'react';
import { FaMap, FaTable } from 'react-icons/fa';

const ViewToggle = ({ view, onViewChange }) => {
  return (
    <div className="inline-flex rounded-lg border border-gray-300 bg-white p-1">
      <button
        onClick={() => onViewChange('map')}
        className={`flex items-center gap-2 px-4 py-2 rounded-md transition-all duration-200 ${
          view === 'map'
            ? 'bg-blue-600 text-white shadow-sm'
            : 'text-gray-700 hover:bg-gray-100'
        }`}
      >
        <FaMap className="text-sm" />
        <span className="font-medium">Map View</span>
      </button>
      <button
        onClick={() => onViewChange('table')}
        className={`flex items-center gap-2 px-4 py-2 rounded-md transition-all duration-200 ${
          view === 'table'
            ? 'bg-blue-600 text-white shadow-sm'
            : 'text-gray-700 hover:bg-gray-100'
        }`}
      >
        <FaTable className="text-sm" />
        <span className="font-medium">Table View</span>
      </button>
    </div>
  );
};

export default ViewToggle;
